"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TicketsModule = /** @class */ (function () {
    function TicketsModule() {
    }
    return TicketsModule;
}());
exports.TicketsModule = TicketsModule;
